export default "/images/silent-hill-fate.png";